import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  icon: (props) => {
    let scale;
    let rotate;
    if (theme.defaultIconsDirection === 'ltr' && props.flipViaDirection) {
      scale = 'scale(-1, 1)';
    }
    if (props.rotation) {
      rotate = `rotate(${props.rotation}deg)`;
    }
    const transform = (scale || rotate) ? [scale, rotate].join(' ') : null;

    return {
      display: 'inline-block',
      verticalAlign: 'middle',
      textDecoration: 'inherit',
      width: `${props.size}px`,
      height: `${props.size}px`,
      lineHeight: `${props.size}px`,
      marginRight: '.2em',
      marginLeft: '.2em',
      color: props.color,
      transform: transform || 'none',
    };
  },
}));

export default useStyle;
